export default __webpack_public_path__ + "static/media/p06 p04.57308c15.jpg";